import BasePolicy from '@/policies/BasePolicy.js';

export default class EbookPolicy extends BasePolicy {
    viewAny(user) {
        const permission = 'can access system ebooks';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    /**
     * Mirrors the backend: Owner always passes (Gate::before), everyone else needs the
     * permission directly or through a group. Call it as "_revertDecline" so the
     * BasePolicy is_admin bypass does not show the action to an Admin or Instruction
     * Admin whose role lacks the permission.
     */
    revertDecline(user) {
        const permission = 'revert ebook declines';

        return user.hasRole('Owner') || user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    manageScheduledReports(user) {
        return user.hasPermissionTo('manage ebook scheduled reports');
    }

    hasAdminAccess(user) {
        return user;
    }
}
